export default __webpack_public_path__ + "static/media/default-product.866f9bc5.png";